const ConnectionStatus = Object.freeze({
  READY: 0,
  CONNECTING: 1,
  FINISHED: 2
})

export { ConnectionStatus }
